
import { VOLUME_BUTTON_CLICK } from "@/constants/MixpanelEvents.js";
export default {
  props: {
    colorProp: {
      type: String,
      default: "#363636"
    },
    sizeProp: {
      type: String,
      default: "16px"
    }
  },
  data() {
    return {
      volumeEnabled: null
    };
  },
  watch: {
    volumeEnabled(val) {
      this.$ls.set("volumeEnabled", val);
      this.mixPanelTrackEvent(VOLUME_BUTTON_CLICK, { status: val });
      if (!val) {
        this.$nuxt.$emit("stop-audio-alert");
      }
    }
  },
  created() {
    if (this.$ls.get("volumeEnabled", "") === "") {
      this.volumeEnabled = true;
      this.$ls.set(true);
    } else {
      this.volumeEnabled = JSON.parse(this.$ls.get("volumeEnabled"));
    }
  }
};
